import { render, staticRenderFns } from "./appel_service_type.vue?vue&type=template&id=1b2018ba"
import script from "./appel_service_type.vue?vue&type=script&lang=js"
export * from "./appel_service_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports